import {
    FILTER_QUERY_KEYS,
    PackagingPOFilterConfigArray,
    PackagingPOSortConfig,
} from 'components/packaging/components/packagingPOV2/PackagingPOFilterConfig';

export { FILTER_QUERY_KEYS };

const PARTNER_EXCLUDED_FILTER_KEYS = new Set(['companySourceIds', 'deliveryDateRange', 'vendorIds']);

export const PartnerPackagingPurchaseOrderFilterConfigArray = PackagingPOFilterConfigArray.filter(
    (cfg) => !PARTNER_EXCLUDED_FILTER_KEYS.has(cfg.key),
).map((cfg) => (cfg.key === 'facilityIds' ? { ...cfg, label: 'Facility' } : cfg));

export { PackagingPOSortConfig as PartnerPackagingPOSortConfig };

/** Partner packaging URL/API transform — excludes vendor, delivery date, and company source (injected by shell). */
export const PartnerPackagingPOTransformConfig = {
    numericArrayKeys: ['facilityIds'],
    stringArrayKeys: ['statuses'],
};
